import React, { useState, useRef } from 'react';
import { generateCertificatePDF } from './CertificatePDF';

function generateCertNumber() {
  const monthPrefixes = [
    'СІ', 'ЛЮ', 'БЕ', 'КВ', 'ТР', 'ЧЕ',
    'ЛИ', 'СЕ', 'ВЕ', 'ЖО', 'ЛС', 'ГР'
  ];
  const month = new Date().getMonth();
  const prefix = monthPrefixes[month];
  const digits = '0123456789';
  let num = '';
  for (let i = 0; i < 6; i++) {
    num += digits.charAt(Math.floor(Math.random() * digits.length));
  }
  return prefix + '-' + num;
}

function formatDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

function addMonths(date, months) {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
}

const CertificateForm = ({ onGenerated }) => {
  const [clientName, setClientName] = useState('');
  const [type, setType] = useState('amount');
  const [value, setValue] = useState('');
  const [generating, setGenerating] = useState(false);
  const [lastPDF, setLastPDF] = useState(null);
  const [lastCertData, setLastCertData] = useState(null);
  const previewRef = useRef(null);

  const today = new Date();
  const expiryDate = addMonths(today, 6);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGenerating(true);

    const certData = {
      number: generateCertNumber(),
      clientName: clientName.trim(),
      type,
      value: value.trim(),
      issueDate: formatDate(today),
      expiryDate: formatDate(expiryDate),
    };

    try {
      var result = generateCertificatePDF(certData);
      setLastPDF(result);
      setLastCertData(certData);

      if (onGenerated) {
        onGenerated(certData);
      }
      setClientName('');
      setValue('');

      // Scroll to preview
      setTimeout(() => {
        if (previewRef.current) {
          previewRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } catch (err) {
      alert('Помилка при генерації PDF: ' + err.message);
    }

    setGenerating(false);
  };

  const handleShare = async () => {
    if (!lastPDF) return;
    try {
      if (navigator.share && navigator.canShare && navigator.canShare({ files: [lastPDF.file] })) {
        await navigator.share({
          files: [lastPDF.file],
          title: 'Сертифікат ALENA.BOTOX',
          text: 'Подарунковий сертифікат на послуги косметолога',
        });
      } else {
        var url = URL.createObjectURL(lastPDF.blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = lastPDF.fileName;
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      if (err.name !== 'AbortError') {
        alert('Не вдалося поділитися: ' + err.message);
      }
    }
  };

  const handleDownload = () => {
    if (!lastPDF) return;
    var url = URL.createObjectURL(lastPDF.blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = lastPDF.fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleNewCert = () => {
    setLastPDF(null);
    setLastCertData(null);
  };

  // If we have a generated cert, show preview
  if (lastCertData && lastPDF) {
    const displayValue = lastCertData.type === 'amount'
      ? lastCertData.value + ' грн'
      : lastCertData.value;
    const labelText = lastCertData.type === 'amount' ? 'Сума:' : 'Процедура:';

    return (
      <div className="cert-form-wrapper" ref={previewRef}>
        <div className="cert-preview">
          <div className="cert-preview-card">
            <div className="cert-preview-border">
              <h1 className="cert-preview-title">ALENA.BOTOX</h1>
              <p className="cert-preview-subtitle">ЛІКАР КОСМЕТОЛОГ</p>
              <p className="cert-preview-subtitle">АВТОР ТВОЄЇ ВИРАЗНОЇ КРАСИ</p>

              <div className="cert-preview-divider">
                <span className="cert-preview-diamond"></span>
              </div>

              <h2 className="cert-preview-heading">СЕРТИФІКАТ</h2>
              <p className="cert-preview-subheading">НА ПОСЛУГИ КОСМЕТОЛОГА</p>

              <div className="cert-preview-field">
                <span className="cert-preview-label">Для:</span>
                <span className="cert-preview-value cert-preview-handwritten">{lastCertData.clientName}</span>
                <div className="cert-preview-line"></div>
              </div>

              <div className="cert-preview-field">
                <span className="cert-preview-label">{labelText}</span>
                <span className="cert-preview-value cert-preview-handwritten">{displayValue}</span>
                <div className="cert-preview-line"></div>
              </div>

              <p className="cert-preview-validity">СЕРТИФІКАТ МОЖНА ВИКОРИСТАТИ</p>
              <p className="cert-preview-validity">ПРОТЯГОМ 6 МІСЯЦІВ</p>

              <div className="cert-preview-dates">
                <span>Дата видачі: {lastCertData.issueDate}</span>
                <span>Дійсний до: {lastCertData.expiryDate}</span>
              </div>

              <p className="cert-preview-number">№ {lastCertData.number}</p>

              <div className="cert-preview-divider">
                <span className="cert-preview-diamond"></span>
              </div>

              <p className="cert-preview-contacts">+38063 738 5557 &nbsp;|&nbsp; @ALENA.BOTOX</p>
            </div>
          </div>
        </div>

        <div className="cert-actions">
          <button type="button" className="cert-btn cert-btn-share" onClick={handleShare}>
            Поділитися
          </button>
          <button type="button" className="cert-btn cert-btn-download" onClick={handleDownload}>
            Завантажити
          </button>
        </div>

        <button type="button" className="cert-btn cert-btn-new" onClick={handleNewCert}>
          Створити новий сертифікат
        </button>
      </div>
    );
  }

  return (
    <div className="cert-form-wrapper">
      <h3>Створити сертифікат</h3>
      <form onSubmit={handleSubmit} className="cert-form">
        <div className="cert-form-row">
          <div className="cert-field">
            <label>Ім'я клієнта</label>
            <input
              type="text"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              placeholder="Ім'я та прізвище"
              required
            />
          </div>
        </div>

        <div className="cert-form-row">
          <div className="cert-field">
            <label>Тип сертифікату</label>
            <div className="cert-type-toggle">
              <button
                type="button"
                className={`cert-type-btn ${type === 'amount' ? 'active' : ''}`}
                onClick={() => { setType('amount'); setValue(''); }}
              >
                Сума
              </button>
              <button
                type="button"
                className={`cert-type-btn ${type === 'procedure' ? 'active' : ''}`}
                onClick={() => { setType('procedure'); setValue(''); }}
              >
                Процедура
              </button>
            </div>
          </div>
        </div>

        <div className="cert-form-row">
          <div className="cert-field">
            <label>{type === 'amount' ? 'Сума (грн)' : 'Назва процедури'}</label>
            <input
              type={type === 'amount' ? 'number' : 'text'}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={type === 'amount' ? '2000' : 'Збільшення губ'}
              required
            />
          </div>
        </div>

        <div className="cert-form-row cert-dates">
          <div className="cert-date-info">
            <span>Дата видачі: <strong>{formatDate(today)}</strong></span>
            <span>Дійсний до: <strong>{formatDate(expiryDate)}</strong></span>
          </div>
        </div>

        <button type="submit" className="cert-btn cert-btn-generate" disabled={generating}>
          {generating ? 'Генерую...' : 'Згенерувати'}
        </button>
      </form>
    </div>
  );
};

export default CertificateForm;
